import { render, staticRenderFns } from "./HomepageProductDetail.vue?vue&type=template&id=bbedb54e&scoped=true&"
import script from "./HomepageProductDetail.vue?vue&type=script&lang=js&"
export * from "./HomepageProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./HomepageProductDetail.vue?vue&type=style&index=0&id=bbedb54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbedb54e",
  null
  
)

export default component.exports